import AuthorizationModal from './AuthorizationModal';

export default AuthorizationModal;
